export const CONTAINER_WIDTH = 1200;
export const HOME_PAGE_CONTAINER_WIDTH = 1500;
export const HOME_PAGE_FOOTER_CONTAINER_WIDTH = 1360;
export const FULL_WIDTH = '100%';
export const EFES_CONTENT_WIDTH = 740;
export const EFES_SUMMARY_WIDTH = 460;
